import { styled, css } from "styled-components";
import { transition } from "../../styles/mixins";

const Button = styled.button`
  ${transition('opacity, scale, filter')}
  align-items: center;
  background-color: transparent;
  border-color: ${props => props.$action ? 'var(--color-theme-accent-400)' : 'var(--color-theme-secondary-400)'};
  border-style: solid;
  border-width: var(--border-width);
  color: ${props => props.$action ? 'var(--color-theme-accent-400)' : 'var(--color-theme-secondary-400)'};
  cursor: pointer;
  display: inline-flex;
  font-size: inherit;
  font-weight: inherit;
  gap: var(--space-1);
  justify-content: center;
  min-height: var(--space-8);
  padding-inline: var(--space-3);
  position: relative;
  scale: 1;
  text-align: center;
  z-index: 0;

  ${(props) => props.$disabled && css`
    opacity: 0.5;
    pointer-events: none;
  `}

  ${props => props.$action == 'icon' && css`
    aspect-ratio: 1;
    border-radius: 100%;
    padding-inline: 0;
  `}

  ${props => props.$icon && css`
    aspect-ratio: 1;
    padding-inline: 0;
  `}

  &:hover {
    filter: brightness(150%);
  }

  &:active {
    scale: 0.88;
  }
`;

export const ButtonGroup = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
  width: 100%;

  .split {
    margin-right: auto;
  }
`;


export default Button;